import SectionEditor from "./SectionEditor";

export default SectionEditor;
